module.exports = __webpack_public_path__ + "img/charcoal.2d97bef0.jpg";